import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { computed } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'Marker',
    props: {
        mark: {}
    },
    setup: function (__props) {
        var props = __props;
        var label = computed(function () { return typeof props.mark === 'string' ? props.mark : props.mark.label; });
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock("div", {
                style: _normalizeStyle(_ctx.mark.style || {}),
                class: "e-range-slider__marks-text"
            }, _toDisplayString(label.value), 5));
        };
    }
});
